import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'paginate'})
export class PaginatePipe implements PipeTransform {
  transform(array: any, pageSize: number, pageNum: number) {
    return array.slice((pageNum - 1) * pageSize, (pageNum - 1) * pageSize + pageSize);
  }
}
